import styled from 'styled-components';
import { media } from '../../styles/theme';

export const Container = styled.footer`
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.espaco.sm};
  width: 100%;
  padding: ${({ theme }) => theme.espaco.sm};
  background-color: ${({ theme }) => theme.cores.primary};
  z-index: ${({ theme }) => theme.zIndex.sidebar};

  img {
    height: 24px;
    width: 24px;
  }

  a {
    color: ${({ theme }) => theme.cores.inkInverse};
    font-size: ${({ theme }) => theme.fonte.small};
    text-decoration: none;

    &:hover {
      color: ${({ theme }) => theme.cores.accent};
    }
  }

  ${media.mobile} {
    img {
      height: 20px;
      width: 20px;
    }

    a {
      font-size: ${({ theme }) => theme.fonte.caption};
    }
  }
`;
